import React from 'react';
import { Container, TextLocalized, ContainerFlex, Button, Card } from '../components/styled/Styled';
import img_home from '../img/background-home.jpg';

import partner1 from '../img/partner1.png';
import partner2 from '../img/partner2.png';
import partner3 from '../img/partner3.png';

import home2 from '../img/home_two.jpg';
import logo_revolve from '../img/logo_revolve.png';

import { useNavigate } from 'react-router-dom';

const HomeView = () => {
    let history = useNavigate();

    return (
        <Container minheight="calc(100vh - 80px)" color="color-white">
            <Container width="12" image={img_home}>
                <ContainerFlex width="12" pv="200" justify="center" fontWeight="bold" fontSize="37px" color="color-primary-a40" fontColor="color-white" textAlign="center">
                    <ContainerFlex width="12" justify="center" textAlign="center" children={<TextLocalized width="12" children="msgHomeTitleOne" />} />
                    <ContainerFlex width="8" fontWeight="400" fontSize="18px" justify="center" ph="32" mv="16" children={<TextLocalized children="msgHomeSubTitle" />} />
                </ContainerFlex>
            </Container>

            <ContainerFlex width="12" justify="center" pv="48">
                <ContainerFlex width="12" lg="9" align="stretch">
                    <Container width="12" textAlign="center" fontSize="40px" fontWeight="bold" fontColor="color-black" children={<TextLocalized children="msgHomeSection2" />} />
                    <Container width="12" lg="6" pv="32">
                        <Container width="12" mt="16" children={<TextLocalized children="msgHomeSection2Text" />} />
                    </Container>

                    <Container width="0" lg="6" px="32">
                        <Card flex width="12" height="100%" image={home2} radius="20px" />
                    </Container>

                    <Container width="12" lg="6" pv="32">
                        <Container width="12" mt="16" children={<TextLocalized children="msgHomeSection21Text" />} />

                        <Button onClick={() => history("/login")} mt="64" ph="64" pv="16" color="color-black" hoverColor="color-black-dark" radius="30px" fontSize="17px" fontWeight="normal" fontColor="color-white" textAlign="center">
                            <TextLocalized children="msgHomeSection2Btn" />
                        </Button>

                        <Button onClick={() => history("/register")} mv="16" ph="64" pv="16" fontSize="16px" fontWeight="normal" hoverColor="color-gray" radius="30px" fontColor="color-black" textAlign="center">
                            <TextLocalized children="actionAlready" />
                        </Button>
                    </Container>

                    <Container width="0" lg="6" px="32">
                        <Card flex width="12" height="80%" image={logo_revolve} radius="20px" />
                    </Container>
                </ContainerFlex>
            </ContainerFlex>

            <ContainerFlex width="12" pv="48" justify="center" color="color-primary-a40">
                <Container width="12" fontSize="38px" fontWeight="bold" fontColor="color-black" textAlign="center">
                    <TextLocalized children="msgHomeSection3" />
                </Container>

                <ContainerFlex width="12" lg="10" justify="center" align="center" mv="32">
                    <img alt="partner-2" width="280" style={{ padding: '32px' }} src={partner2} />
                    <img alt="partner-1" width="280" style={{ padding: '32px' }} src={partner1} />
                    <img alt="partner-3" width="280" style={{ padding: '32px' }} src={partner3} />
                </ContainerFlex>
            </ContainerFlex>

        </Container>
    );
};

export default HomeView;